import { useField, useFormikContext } from 'formik';
import { Input, InputProps } from '@antimatterhq/ui/components/input';
import { useCheckFormikError } from '@/hooks/formik/useCheckFormikError';
import { cn } from '@/lib/utils';

export const FormInput = ({
  name = '',
  disabled = false,
  className = '',
  ...props
}: InputProps) => {
  const [field] = useField(name);
  const { isSubmitting } = useFormikContext();
  const { error } = useCheckFormikError({ name });
  const variant = error ? 'error' : 'default';
  // eslint-disable-next-line
  props = { ...field, ...props };
  return (
    <Input
      name={name}
      variant={variant}
      disabled={isSubmitting || disabled}
      className={cn('max-w-form', className)}
      autoComplete="off"
      data-testid={`form-input-${name}`}
      {...props}
    />
  );
};
